module.exports = __webpack_public_path__ + "fwm_h5/img/gongzhonghao.97a531da.png";